module.exports = __webpack_public_path__ + "static/media/preventivostickets-06-rojo.0222fa52.svg";